import {handleLogout} from "components/utils"; import React, {useEffect, useState} from 'react';
import axios from "axios";
import {ClientSessionReadOnly} from "../client/ClientSessionReadOnly";
import {Accordion, Button, Modal} from "react-bootstrap";
import {QueuingView} from "./QueuingView";
import {PostReviewView} from "./PostReviewView";
import {CustomerQueuingView} from "./CustomerQueuingView";

export const CustomerView = (props: { clientProfiles: Array<any>, businessName: string, businessAddress: string, isQmeEnabled: boolean}) => {

    const [selectedClientProfile, setSelectedClientProfile] = useState(null)
    const [selectedPostReviewQr, setSelectedPostReviewQr] = useState(null)
    const [postReview, setPostRevew] = useState(false)

    const [showQueueModal, setShowQueueModal] = useState(false);
    const handleCloseQueueModal = () => setShowQueueModal(false);
    const handleShowQueueModal = (qrCode: String) => {
        setSelectedClientProfile(props.clientProfiles.filter(value => value.qrCode == qrCode)[0])
        setShowQueueModal(true)
    }

    useEffect(() => {
        if (props.clientProfiles && props.clientProfiles.length == 1 && props.isQmeEnabled) {
            handleShowQueueModal(props.clientProfiles[0].qrCode)
        }
    }, [props.clientProfiles, props.isQmeEnabled])

    function getModalForAddingToQueue() {
        return <Modal
            show={showQueueModal}
            onHide={handleCloseQueueModal}
            backdrop="static"
        >
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-5">
                    <CustomerQueuingView clientProfile={selectedClientProfile} postAction={handleCloseQueueModal} selectedSession={null} selectedDate={null}/>
                </div>
            </Modal.Body>
        </Modal>;
    }

    const [showPostReviewModal, setShowPostReviewModal] = useState(false);
    const handleClosePostReviewModal = () => {

        setShowPostReviewModal(false);
    }
    const handleShowPostReviewModal = (qrCode: String, postReview) => {
        setSelectedPostReviewQr(qrCode)
        setPostRevew(postReview)
        setShowPostReviewModal(true)
    }

    function getModalForPostingReview() {
        return <Modal
            show={showPostReviewModal}
            onHide={handleClosePostReviewModal}
            backdrop="static"
        >
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-5">
                    <PostReviewView qrCode={selectedPostReviewQr} postAction={handleClosePostReviewModal}
                                    isExpanded={postReview}/>
                </div>
            </Modal.Body>
        </Modal>;
    }

    function getClientSummary(profile: any) {
        return <div className="d-flex flex-row align-items-center gap-2 gap-lg-5">
            <div>
                {profile.image && <><img alt="customer-view-page-icon" height="100rem" width="100rem" src={"https://qme-presrc.s3.ap-south-1.amazonaws.com/"+profile.image}
                               className="rounded-circle d-none d-lg-block"/>
                    <img alt="customer-view-page-icon" height="70rem" width="70rem" src={"https://qme-presrc.s3.ap-south-1.amazonaws.com/"+profile.image}
                         className="rounded-circle d-lg-none"/></>}
                {!profile.image && <><img alt="customer-view-page-icon" height="100rem" width="100rem" src="/listings/profile.png"
                     className="rounded-circle d-none d-lg-block"/>
                <img alt="customer-view-page-icon" height="70rem" width="70rem" src="/listings/profile.png"
                     className="rounded-circle d-lg-none"/></>}
            </div>
            <div className="">
                <div className="fs-4 text-secondary d-inline-block py-1">{profile["clientName"]}&nbsp;</div>
                <div className="fs-6 text-secondary d-inline-block py-1">{profile["qualification"] &&
                    <div>({profile["qualification"]})</div>}</div>
                <div className="fs-6 text-secondary font-weight-bold py-1">{profile["category"]}&nbsp;</div>
                <div className="fs-6 text-secondary py-1">{profile["experience"] > 0 &&
                    <div>{profile["experience"]} years experience</div>}
                </div>
            </div>
        </div>;
    }

    return (
        <>
            <div className="row my-4">
                {props.businessName && <>
                    <div className="col-12 fs-2 text-center text-info font-weight-bold">
                        {props.businessName}
                    </div>
                    <div className="text-secondary fs-6 text-center pb-2 pb-lg-4">
                        {props.businessAddress}
                    </div>
                </>
                }
                <div className="col-12">
                    <Accordion className="py-2 py-lg-0" defaultActiveKey="0">
                        {props.clientProfiles && props.clientProfiles.map((profile, index) => {
                            return <Accordion.Item key={"doctor-schedule"} eventKey={index.toString()}>
                                <Accordion.Header>
                                    {getClientSummary(profile)}
                                </Accordion.Header>
                                <Accordion.Body>
                                    <ClientSessionReadOnly cookieQr={profile["qrCode"]}/>
                                    <div className="d-flex flex-row gap-1 py-3">
                                        <div>Upvotes:</div>
                                        <div
                                            className="align-self-center">{profile["upVotePercent"]}%
                                        </div>
                                        <div
                                            className="align-self-center">({profile["upVotes"] + profile["downVotes"]}&nbsp;votes)
                                        </div>
                                    </div>
                                    {profile.reviewsResponse && profile.reviewsResponse.reviews && profile.reviewsResponse.reviews.map((review) => {
                                        return review.reviewText && <div key={"review"} className="text-secondary">
                                            <div className="font-weight-bold d-inline-block">{review.reviewerName}</div>
                                            {review.voteType == "up" &&
                                                <img alt="customer-view-page-icon" height="30rem" width="30rem" src="/upvote.png"
                                                     className="align-self-center  d-inline-block"/>
                                            }
                                            {review.voteType == "down" &&
                                                <img alt="customer-view-page-icon" height="30rem" width="30rem" src="/downvote.png"
                                                     className="align-self-center  d-inline-block"/>
                                            }
                                            <p>{review.reviewText}</p>
                                        </div>
                                    })
                                    }
                                    {profile.reviewsResponse && profile.reviewsResponse.reviews && profile.reviewsResponse.totalReviews > profile.reviewsResponse.reviews.length &&
                                        <div><a href="#/" className="text-secondary"
                                                onClick={e => handleShowPostReviewModal(profile["qrCode"], false)}>See
                                            all {profile.reviewsResponse.totalReviews} reviews...</a><br/><br/></div>
                                    }

                                    <div className="d-flex justify-content-between pt-3">
                                        <button className="btn btn-warning text-white"
                                                onClick={e => handleShowPostReviewModal(profile["qrCode"], true)}> Post
                                            Review
                                        </button>
                                        {props.isQmeEnabled && <button className="btn btn-info text-white"
                                                onClick={e => handleShowQueueModal(profile["qrCode"])}> Queue Me
                                        </button>}
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        })
                        }
                    </Accordion>
                    {getModalForAddingToQueue()}
                    {getModalForPostingReview()}
                </div>
            </div>
        </>
    );
};
